// For more Icons take a lokk at https://fontawesome.com/

const WLCONFG= {
    // Language variant: set to true to use formal German (Sie) texts from languages/index_de_sie.js
    // If omitted or false, default informal German (Du) from languages/index.js will be used.
    USE_SIE_FORMAL:                 true,

    SHOW_BLOG:                      false,
    SHOW_AI:                        false,
    USE_CONTENT_IMAGE_ERROR_PAGE:   true,
    USE_CONTENT_IMAGE_THANKS_PAGE:  false,
    SHOW_DASHBOARD_SIDEBAR:         false,
    SHOW_BLOG_SIDEBAR:              true,
    SHOW_BLOG_ARTICLE_SIDEBAR:      true,
    SHOW_ACADEMY_SIDEBAR:           false,
    SHOW_ACADEMY_LESSON_SIDEBAR:    true,
    SHOW_PRODUCT_SIDEBAR:           false,
    SHOW_CHECKLIST_SIDEBAR:         false,
    SHOW_STATISTIC_SIDEBAR:         false,
    SHOW_TRANSCRIBER_SIDEBAR:       false,
    SHOW_AITOOLS_SIDEBAR:           false,
    ACCESSLEVEL:                    '-1',
    ICON_NAVIGATION_DASHBOARD:      'gauge-high',
    ICON_NAVIGATION_MY_PRODUCTS:    'cart-arrow-down',
    ICON_NAVIGATION_STATISTICS:     'chart-pie',
    ICON_NAVIGATION_ACADEMY:        'graduation-cap',
    ICON_NAVIGATION_BLOG:           'book',
    ICON_NAVIGATION_AI:             'robot',
    ICON_NEWS:                      'bullhorn',
    ICON_CHARTS:                    'chart-area',
    ICON_OFFER:                     'basket-shopping',
    LOGO_SIGNET:                    'signet-matthes.svg',
    LOGO:                           'logo-matthes-academy.svg',
    LOGO_WIDTH:                     150, //ist irgendwie sinnlos
    LOGO_WIDTH_CLASS:               'w-50',
    ERROR_LOGO:                     'logo-matthes-academy.svg', //'error_logo.svg',
	DASHBORAD_VIDEO:                'intro-gm.mp4',
	DASHBORAD_VIDEO_POSTER:         'poster-gm.jpg',
    APP_META_TITLE:                 'Gerhard Matthes',
    FAVICON_FOLDER:                 'gm',
    META_SAFE_EQUIV:                'academy.gerhard-matthes.com',
    COMPANY_NAME:                   'Gerhard Matthes Academy',
    COMPANY_SHORT_NAME:             'Gerhard Matthes',
    COMPANY_ADDRESS:                'An der Modau 20, 64372 Ober-Ramstadt, Deutschland',
    COMPANY_EMAIL:                  'service@gerhard-matthes.com',
    COMPANY_PHONE:                  '061 67 / 91 26 18',
    CHAPTER_ADD_CART_ICON_ACTIVE:   'chapter-add-to-cart-icon-active-sb', //css in LessonChapterPayment.vue definieren
    CHAPTER_ADD_CART_ICON_INACTIVE: 'chapter-add-to-cart-icon-inactive-sb', //css in LessonChapterPayment.vue definieren
    NEWSFEED:                       './staticMockData/news_gm.json',
    FACEBOOK_PIXEL_FILE:            './staticMockData/fb_gm.html',
}

export  {
    WLCONFG
}
